module.exports = __webpack_public_path__ + "img/chevron-compact-2-up.ac6de324.svg";